import { useFormContext } from '@calendly/form'

import { SingleHost } from '../../free_busy_rules/single_host'

export const CrudBookingExceptions = ({ variant = 'legacy' }) => {
  const { values: { doubleBookingRuleMemberships } } = useFormContext()

  if (!doubleBookingRuleMemberships?.[0]) return null

  return (
    <SingleHost doubleBookingRuleMembership={doubleBookingRuleMemberships[0]} variant={variant} />
  )
}
